module.exports = __webpack_public_path__ + "static/media/exclamation-mark.b95d71bd.svg";